import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)


const routes = [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home
    // },
    {
        path: '/Main',
        name: 'Main',
        title:"有巢氏整装卫浴",
        component: resolve => require(['@/components/Main/index.vue'], resolve),
        // component: () => import(/* webpackChunkName: "home" */ '../components/Visualization.vue'),
        // require(['@/views/Main'],resolve)
        //   component: () => import(/* webpackChunkName: "home" */ '@/views/Main.vue'),
        meta: {
            title: '有巢氏整装卫浴'
        },

    },

    {
        path: '/Tips',
        name: 'Tips',
        title:"有巢氏整装卫浴",
        component: resolve => require(['@/components/Tips/index.vue'], resolve),
        // component: () => import(/* webpackChunkName: "home" */ '../components/Visualization.vue'),
        // require(['@/views/Main'],resolve)
        //   component: () => import(/* webpackChunkName: "home" */ '@/views/Main.vue'),
        meta: {
            title: '有巢氏整装卫浴'
        },

    },


    {
        path: '/Test',
        name: 'Test',
        title:"有巢氏整装卫浴",
        component: resolve => require(['@/components/Test/index.vue'], resolve),
        // component: () => import(/* webpackChunkName: "home" */ '../components/Visualization.vue'),
        // require(['@/views/Main'],resolve)
        //   component: () => import(/* webpackChunkName: "home" */ '@/views/Main.vue'),
        meta: {
            title: '有巢氏整装卫浴'
        },

    },


]

const router = new VueRouter({
    mode: 'history',
    // mode: "hash",//此处如果是history，需要修改为hash
    base: process.env.BASE_URL,
    // base:"dist",
    routes
})

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }


router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

export default router
